<template>
  <div id="app" :class="rtl()">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  methods: {
    rtl(){
      if(this.language === 'ar'){
        return 'style-ar'
      }
    }
  }
}
</script>

<style lang="scss">
  @import './assets/sass/style.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue